import React from "react";
import { ListUsersSessionSeller } from "../widget/ListUsersSessionSeller";
import { StatisticSeller } from "../widget/StatisticSeller";
import { useIntl } from "react-intl";

const GeneralView: React.FC = () => {
  const intl = useIntl();
  return (
    <>
      {/* begin::Col */}
      <div className="accordion-collapse collapse show col-md-3 col-lg-3 col-xl-3 col-xxl-3">
        <div className="accordion">
          <div className="accordion-item">
            <h2 className="accordion-header" id="headingOne">
              <button
                className="accordion-button bg-black"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseOne"
                aria-expanded="true"
                aria-controls="collapseOne"
              >
                {intl.formatMessage({
                  id: "MENU.DASHBOARD_PLANS_SALES.OVERDUE_VISITOR",
                })}
                7
              </button>
            </h2>
            <div
              id="collapseOne"
              className="accordion-collapse collapse show"
              aria-labelledby="headingOne"
            >
              <div className="accordion-body" style={{ overflowX: "scroll" }}>
                <ListUsersSessionSeller
                  className="card-xl-stretch mb-8"
                  cardHeight="300px"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* end::Col */}

      {/* begin::Col */}

      <StatisticSeller
        className="col-md-6 col-lg-6 col-xl-6 col-xxl-6"
        chartHeight="50"
        chartColor="blue"
      />
      {/* end::Col */}

      {/* begin::Col */}
      <div className="col-md-3 col-lg-3 col-xl-3 col-xxl-3">
        <div className="list-group margin-left-100">
          <button
            type="button"
            className="btn btn-secondary w-100  mt-2"
            title="Only with password"
          >
            {intl.formatMessage({
              id: "MENU.DASHBOARD_PLANS_SALES.REPORT",
            })}
          </button>
          <button
            type="button"
            className="btn btn-secondary w-100  mt-2"
            title="Only with password"
          >
            {intl.formatMessage({
              id: "MENU.DASHBOARD_PLANS_SALES.GOALS",
            })}
          </button>
          <button type="button" className="btn btn-secondary w-100 mt-2">
            {intl.formatMessage({
              id: "MENU.DASHBOARD_PLANS_SALES.WHATSAPP",
            })}
          </button>
        </div>
      </div>
      {/* end::Col */}

      {/* begin::Col */}
      <div
        className="accordion col-md-6 col-lg-6 col-xl-6 col-xxl-6 "
        style={{ overflowX: "scroll" }}
      >
        <div className="accordion-item ">
          <h2 className="accordion-header" id="headingSix">
            <button
              className="accordion-button collapsed bg-black align-items-center, fs-bold,"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseTwo"
            >
              <p className="position-absolute top-50 start-50 translate-middle fs-5 fw-bold">
                {intl.formatMessage({
                  id: "MENU.DASHBOARD_PLANS_SALES.LIST_VISITOR",
                })}
                20
              </p>
              <input type="date" className="form-control w-25 p-3" />
            </button>
          </h2>
          <div
            id="collapseTwo"
            className="accordion-collapse collapse hide"
            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body">
              <ListUsersSessionSeller className="" cardHeight="380px" />
            </div>
          </div>
        </div>
      </div>
      {/* end::Col */}
    </>
  );
};

export default GeneralView;
